import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '@base-shared/services/helpers.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {

  title = 'cobuild-angular-boilerplate';

  constructor(
    private helpers: HelpersService
  ) {
    this.helpers.bootstrapLang();
  }

}
